import McPanelGroup from './McPanelGroup';

export default McPanelGroup;
